module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "短信账户",
      "name": "first"
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "warning",
      "title": "短信推送",
      "show-icon": "",
      "description": "短信推送即通过发送短信，给买家推送交易等提醒信息，包括付款、预约、核销等，以提升买家的到店体验，获得会员到店转化率和复购率。"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-padded message-content"
  }, [_vm._v("短信余额："), _c('span', {
    staticClass: "message-count"
  }, [_vm._v(_vm._s(_vm.messageCount))]), _vm._v("条 "), _c('a', {
    attrs: {
      "href": _vm.sms_buy_url,
      "target": "_blank"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("去充值")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "短信模板",
      "name": "second"
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": "短信模版详情",
      "size": "tiny",
      "visible": _vm.detailDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否开启"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": " ",
      "active-value": "true",
      "inactive-text": " ",
      "active-color": "#13ce66"
    },
    on: {
      "change": _vm.openChange
    },
    model: {
      value: (_vm.currentTemplate.is_open),
      callback: function($$v) {
        _vm.$set(_vm.currentTemplate, "is_open", $$v)
      },
      expression: "currentTemplate.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发送时间点"
    }
  }, [_vm._v(_vm._s(_vm.currentTemplate.send_time_desc.title))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "短信内容"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "textarea",
      "rows": 5,
      "readonly": true
    },
    model: {
      value: (_vm.currentTemplate.content),
      callback: function($$v) {
        _vm.$set(_vm.currentTemplate, "content", $$v)
      },
      expression: "currentTemplate.content"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "message-template"
  }, _vm._l((_vm.smsTemlateList), function(items, index) {
    return _c('div', [_c('div', {
      staticClass: "section-header with-border"
    }, [(index == 'promotions') ? _c('span', [_vm._v("营销权益")]) : _vm._e(), _vm._v(" "), (index == 'member') ? _c('span', [_vm._v("会员关怀")]) : _vm._e(), _vm._v(" "), (index == 'trade') ? _c('span', [_vm._v("交易提醒")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-body"
    }, _vm._l((items), function(row) {
      return _c('div', {
        staticClass: "item",
        class: row.is_open == 'true' ? 'succ-open-sms' : 'not-open-sms',
        on: {
          "click": function($event) {
            return _vm.toDetail(row)
          }
        }
      }, [_c('div', {
        staticClass: "item-title clearfix"
      }, [_vm._v(_vm._s(row.send_time_desc.tmpl_title) + " "), _c('i', {
        staticClass: "el-icon-arrow-right"
      })]), _vm._v(" "), _c('div', {
        staticClass: "item-content"
      }, [_vm._v(_vm._s(row.content))]), _vm._v(" "), _c('div', {
        staticClass: "item-footer"
      }, [(row.is_open == 'true') ? _c('el-button', {
        attrs: {
          "type": "default",
          "size": "small"
        }
      }, [_vm._v("启用中")]) : _c('el-button', {
        attrs: {
          "type": "default",
          "size": "small"
        }
      }, [_vm._v("未启用")])], 1)])
    }), 0)])
  }), 0)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "短信签名",
      "name": "third"
    }
  }, [_c('div', {
    staticClass: "content-padded message-autograph"
  }, [_vm._v("短信签名：\n        "), _c('el-input', {
    attrs: {
      "placeholder": "请输入短信签名"
    },
    model: {
      value: (_vm.messageAutograph),
      callback: function($$v) {
        _vm.messageAutograph = $$v
      },
      expression: "messageAutograph"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveSmsSignAction
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('div', {
    staticClass: "message-prompt"
  }, [_c('div', {
    staticClass: "prompt-title"
  }, [_c('span', [_vm._v("常见问题：")])]), _vm._v(" "), _c('div', {
    staticClass: "prompt-content"
  }, [_c('div', {
    staticClass: "prompt-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("1. 签名设置规则")]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', [_vm._v("自定义签名字数限制为2-8个字，可以包含数字、英文；")]), _vm._v(" "), _c('div', [_vm._v("建议使用你的『店铺名』或『品牌名』，使用其他签名可能短信审核不会通过！")]), _vm._v(" "), _c('div', [_vm._v("短信签名不宜频繁修改，请谨慎设置；")]), _vm._v(" "), _c('div', [_vm._v("若签名内容侵犯到第三方权益必须获得第三方真实授权；")]), _vm._v(" "), _c('div', [_vm._v("签名设置规范详见 "), _c('a', {
    attrs: {
      "href": "http://bbs.shopex.cn/forum.php?mod=viewthread&tid=4397&extra=",
      "target": "_blank"
    }
  }, [_vm._v("http://bbs.shopex.cn/forum.php?mod=viewthread&tid=4397&extra=")])])])]), _vm._v(" "), _c('div', {
    staticClass: "prompt-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("2. 签名会出现在哪些短信中？")]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', [_vm._v("设置签名后，\"消息推送\"中列出的短信都会带上你的自定义签名，即：")]), _vm._v(" "), _c('div', [_vm._v("交易物流提醒：订单成功、预约成功、核销；")]), _vm._v(" "), _c('div', [_vm._v("营销关怀提醒：获得会员卡、会员卡升级；")])])]), _vm._v(" "), _c('div', {
    staticClass: "prompt-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("3. 短信计价规则")]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', [_vm._v("单条70字，若超出70字需要分成多条时，将按照67字每条计算；")]), _vm._v(" "), _c('div', [_vm._v("一个汉字、数字、字母、空格都算一字；")]), _vm._v(" "), _c('div', [_vm._v("含有标签（如短信签名、商品名、链接）的短信以实际发送时字符数计算。")])])])])])])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-64a9e5e9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a9e5e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/shortmessage/index.vue
// module id = 2782
// module chunks = 0